import { CharterType } from "__generated__/enums";
import { Tag, TagSize } from "@cofano/cck";
import { intl } from "LocaleWrapper";
import React from "react";
import { getCharterTypeColor } from "view/charters/utils/CharterUtils";

type CharterTypeTagProps = {
	type?: CharterType | null;
	customText?: string;
}

const CharterTypeTag = ({ type, customText }: CharterTypeTagProps) => {

	const getText = () => {
		switch (type) {
			case CharterType.Sales:
				return intl.formatMessage({ id: "SALES" });
			case CharterType.Purchase:
				return intl.formatMessage({ id: "PURCHASE" });
		}
	};

	if (type) {
		return (
			<Tag
				color={getCharterTypeColor(type)}
				text={customText || getText() || type}
				size={TagSize.NORMAL} />
		);
	} else {
		return <React.Fragment />;
	}
};

export default CharterTypeTag;
